export default "__VITE_ASSET__d3da29f4__"